import { httpClient } from "@/app/shared/shared-services/httpClient";
import { environment } from "@/environment";

const URL = environment.loyaltyApiBaseUrl;

export default {
  async fetchRewards(query = '') {
    const url = `${URL}v1/rewards${query}`;
    return (await httpClient.get(url)).data;
  },
  async createReward(reward) {
    const url = `${URL}v1/rewards`;
    return await httpClient.post(url, reward);
  },
  async updateReward(reward) {
    const url = `${URL}v1/rewards/${reward.id}`;
    return await httpClient.put(url, reward);
  },
  async removeReward(rewardId) {
    const url = `${URL}v1/rewards/${rewardId}`;
    return await httpClient.delete(url);
  },
};
